import React, { useEffect } from 'react';
import { ThemedView } from '@app/theme';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import gs from '../../../styles/globalStyles';
import VerifyOtp from './VerifyOtp';
import { FetchPortfolioError, FetchPortfolioInitResponse } from '../type';
import useIsMobileBrowser from '@app/hooks/useIsMobileBrowser';
import { Platform } from 'react-native';
import {  trackEvent } from '@app/utils';

type VerifyOtpModalProps = {
    isVisible: boolean;
    onClose: () => void;
    close?: () => void;
    portfolioInitData: FetchPortfolioInitResponse | null;
    userDetails: any;
    defaultRTA: { assetRepository?: string , repositoryName?: string } | undefined;
    mobileNumber: string;
    setPortfolioInitData?: (data: FetchPortfolioInitResponse | null) => void;
    onFetchPortfolio: () => void;
    setErrorModalData: (data: FetchPortfolioError | null) => void;
    onRetryFetch: () => void;
    hasFetchErrorOccured: boolean;
    setHasFetchErrorOccured: (data: boolean) => void;
    onVerifySuccess: (data: FetchPortfolioInitResponse) => void;
    retryingFetchPortfolio?: boolean;
};

const VerifyOtpModal: React.FC<VerifyOtpModalProps> = ({
    isVisible,
    onClose,
    portfolioInitData,
    userDetails,
    defaultRTA,
    mobileNumber,
    onFetchPortfolio,
    setErrorModalData,
    setPortfolioInitData,
    onRetryFetch,
    hasFetchErrorOccured,
    setHasFetchErrorOccured,
    onVerifySuccess,
    retryingFetchPortfolio
}) => {

    useEffect(() => {
        if(isVisible) {
            trackEvent('FETCH_OTP_MODAL_VIEWED', {
                source: defaultRTA?.repositoryName || ''
            })
        }
    }, [isVisible])
    const isMobileBrowser = useIsMobileBrowser()
    return (
        <BottomSheetContainer
            isVisible={isVisible}
            onClose={onClose}
            close={onClose}
            closeOnBackdropPress={false}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            showCloseIcon
            //@ts-expect-error
            containerStyle={[gs.setBg('#fefefe'), {
                maxHeight: Platform.OS === 'web' ? '80%' : undefined,
                minHeight: isMobileBrowser ? 330 : undefined, 
            }]}
        >
            <ThemedView>
                <VerifyOtp
                    applicationId={userDetails?.linkedApplications[0]?.applicationId}
                    assetRepository={defaultRTA?.assetRepository || ''} 
                    otpDigitCount={portfolioInitData?.stepResponseObject?.success?.noOfDigits || 0}
                    source={portfolioInitData?.stepResponseObject?.success?.otpChannel || ''}
                    email={userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail}
                    phoneNumber={`+91 ${mobileNumber}`}
                    onClose={onClose}
                    triggerResendOTP={onFetchPortfolio}
                    onVerifySuccess={onVerifySuccess}
                    setErrorModalData={setErrorModalData}
                    setPortfolioInitData={setPortfolioInitData}
                    onRetryFetch={onRetryFetch}
                    hasFetchErrorOccured={hasFetchErrorOccured}
                    setHasFetchErrorOccured={setHasFetchErrorOccured}
                    retryingFetchPortfolio={retryingFetchPortfolio}
                    title={defaultRTA?.repositoryName + ' has sent an OTP to'}
                />
                {Platform.OS === 'android' && (
                    <ThemedView height={10} />
                )}
            </ThemedView>
        </BottomSheetContainer>
    );
};

export default VerifyOtpModal; 